import $ from 'jquery';
import './carousel.scss';
import './jquery.carouFredSel-6.2.1';
import './jquery.touchSwipe';
import Sloth from '../Sloth';

@Sloth.component({
    defaultOptions : {
        width: null,
        visible: 1,
        scroll: null, // 每次滚动的个数, 默认一屏
        height: 'variable',
        auto: true,
        pauseOnHover: true,
        time: 5000,
        duration: 500
    }
})

export default class Carousel {
    onInit() {
        const dom = this.dom;
        const options = this.options;
        const onCurrentChange = options.visible > 1 ? $.noop : () => {
            $('ul', dom).triggerHandler('currentVisible', (item) => {
                if (!item || item.length === 0) {
                    return;
                }
                const binds = $(item).attrs('data');
                for (const key in binds) {
                    if ($.prototype.hasOwnProperty.call(binds, key)) {
                        $(`[data-bind='${key}']`, dom).html(binds[key]);
                    }
                }
                $('[data-link]', dom).attr('href', $('a', item).attr('href'));
            });
            $('ul', dom).trigger('currentChange');
        };
        this.pluginIntro();
        this.pluginExif();

        if (options.visible > 1) {
            $('.Carousel-pic', dom).css({
                'margin-left':'-15px',
                'margin-right':'-15px'
            });
            $('ul li', dom).css({
                'padding-left':'15px',
                'padding-right':'15px'
            });
        }

        $('ul', dom).carouFredSel({
            auto : {
                play:options.auto,
                pauseDuration:options.pauseduration,
                timeoutDuration: options.time
            },
            responsive: true,
            width: '100%',
            height: 'variable',
            onCreate : onCurrentChange,
            scroll : {
                pauseOnHover:options.pauseOnHover,
                onAfter : onCurrentChange,
                duration: options.duration,
                items: options.scroll || undefined
            },
            items: {
                visible: options.visible,
                width: options.width,
                height: options.height
            },
            swipe : {
                onTouch : true
            },
            pagination : $('.Carousel-pager', dom),
            prev: $('.Carousel-prev', dom),
            next: $('.Carousel-next', dom)
        });

        this.adjustBtnPosition();
        $('ul', dom).trigger('updateSizes'); // 最后调整下
    }

    adjustBtnPosition() {
        const dom = this.dom;
        const options = this.options;

        if (options.visible === 1) {
            return;
        }
        const textHeight = parseInt($('ul', dom).css('height')) - parseInt($('.Carousel-pic img', dom).eq(0).css('height'));
        const selfHeight = $('.Carousel-prev', dom).height();
        $('.Carousel-prev, .Carousel-next', dom).css({
            'margin-top': 0 - selfHeight / 2 - textHeight / 2
        });
        $('.Carousel-pic li', dom).css({
            'padding-left':15,
            'padding-right':15
        });
    }

    pluginExif() {
        if ($('.CarouselPluginExif', this.dom).length === 0) {
            return;
        }
        $('.CarouselPluginExif', this.dom).each((index, obj) => {
            $('.CarouselPluginExif-button', obj).on('click', () => {
                $('.CarouselPluginExif', this.dom).toggleClass('CarouselPluginExif_hide');
            });
        });
    }

    pluginIntro() {
        if ($('.CarouselPluginIntro', this.dom).length === 0) {
            return;
        }
        const that = this;
        $('.CarouselPluginIntro-num .total', this.dom).html($('.Carousel-pic li', this.dom).length);
        $('.CarouselPluginIntro-toggle', this.dom).on('click', function () {
            const isOpen = !$(this).hasClass('CarouselPluginIntro-toggle_up');
            if (isOpen) {
                that.collapse(this.dom);
            } else {
                that.expend(this.dom);
            }
        });
        $('ul', this.dom).on('currentChange', function () {
            that.onChange(this.dom);
        });
    }

    collapse() {
        $('.CarouselPluginIntro-toggle', this.dom).addClass('CarouselPluginIntro-toggle_up');
        $('.CarouselPluginIntro-summary', this.dom).slideUp();
        $('.CarouselPluginIntro-num', this.dom).addClass('CarouselPluginIntro-num_small');
    }

    expend() {
        $('.CarouselPluginIntro-toggle', this.dom).removeClass('CarouselPluginIntro-toggle_up');
        $('.CarouselPluginIntro-summary', this.dom).slideDown();
        $('.CarouselPluginIntro-num', this.dom).removeClass('CarouselPluginIntro-num_small');
    }

    onChange() {
        const currentPosition = $('ul', this.dom).triggerHandler('currentPosition');
        $('.CarouselPluginIntro-num .current', this.dom).html(currentPosition + 1);
        if ($('.CarouselPluginIntro-summary', this.dom).html() === '') {
            $('.CarouselPluginIntro-toggle', this.dom).hide();
            $('.CarouselPluginIntro-num', this.dom).addClass('CarouselPluginIntro-num_small');
        } else {
            $('.CarouselPluginIntro-toggle', this.dom).show();
            $('.CarouselPluginIntro-num', this.dom).removeClass('CarouselPluginIntro-num_small');
        }
    }
}



/** WEBPACK FOOTER **
 ** ./components/Carousel/carousel.js
 **/